import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'wt-ui';
import useDebouncedCallback from 'use-debounce/lib/callback';
import i18next from '../../translations/i18n';
import API from '../../services/API';
import heap from '../../containers/App/heap';

/*
[
  {
    value: i18next.t('Default Question 1'),
  },
  {
    value: i18next.t('Default Question 2'),
  },
  {
    value: i18next.t('Default Question 3'),
  },
];
*/

const AutocompleteSearch = (props) => {
  const { loading, setLoading } = props;
  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState(API.getDefaultSuggestions());

  const [getSuggestionsDebounced, cancelGetSuggestions] = useDebouncedCallback(
    async (value) => {
      const result = await API.getSuggestions(value);
      if (!result) {
        return;
      }
      setSuggestions(result.data.suggestions);
    },
    500,
    [],
  );

  const getAnswer = async (text) => {
    const { onSearchOrResult } = props;

    setLoading(true);
    let answer = await API.getAnswer(text);
    if (!answer) {
      answer = {
        data: {
          error: true,
        },
      };
    }
    setLoading(false);
    onSearchOrResult({
      ...answer.data,
      type: 'azure',
      dtKey: new Date().getTime(),
    });
  };

  const onChange = (event) => {
    // console.log('onChange', event.target.value);
    setSearchText(event.target.value);
    getSuggestionsDebounced(event.target.value);
  };

  const onSearch = (obj) => {
    console.log('onSearch', obj);
    const { onSearchOrResult } = props;
    const toSearch = obj ? obj.value : searchText;

    onSearchOrResult({ type: 'user', message: toSearch, dtKey: new Date().getTime() });

    cancelGetSuggestions();
    setSearchText('');
    setSuggestions(API.getDefaultSuggestions());

    heap.track('SearchQuestion', { question: toSearch });
    getAnswer(toSearch);
  };

  // TODO: add if loading rendering
  return (
    <>
      <style jsx>{`
        input::placeholder {
          overflow: visible;
        }
      `}</style>
      <Input
        value={searchText}
        onChange={onChange}
        placeholder={`${i18next.t('Enter your question about Short and Leveraged products')}...`}
        onSelect={onSearch}
        onEnter={onSearch}
        suggestions={suggestions}
        disabled={loading}
      />
    </>
  );
};

AutocompleteSearch.propTypes = {
  onSearchOrResult: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default AutocompleteSearch;
